import { cn } from "@/lib/utils";

/** Z2Infinity brand mark, sourced from the official logo. */
export const BrandMark = ({ className }) => (
  <img src="/logo.png" alt="Z2Infinity" className={cn("w-auto object-contain", className)} />
);
